export const PDFViewerStyles = {
    container: "w-full max-h-screen relative flex flex-col items-center",
    pageWrapper: "mb-2 border border-gray-200",
};
